
    <div class="container container-extra mt-50" *ngIf="data">

        <app-back-nav class="mb-20" linkText="{{ 'NUMERIC_GOAL.BACK_TO_TEXT_GOALS' | translate }}" [link]="getBackLink()"></app-back-nav>

        <section class="page-title">
            <h1>{{ 'NUMERIC_GOAL.QUANTITATIVE_INDIVIDUAL_GOALS' | translate }}</h1>
            <div class="review-period-info" *ngIf="data">{{ data.employeeName }} | {{ data.goalPeriod.reviewPeriod.name }} | {{ data.goalPeriod.reviewPeriod.startDate | datePlain }} - {{ data.goalPeriod.reviewPeriod.endDate | datePlain }}</div>
        </section>

            <mat-card class="frame main-card p-24">
                <mat-card-content>
                
                    <div class="goal-panel" [formGroup]="mainForm">
                        <div class="content-col">
                            <div class="line1">
                                <div class="goal-head-content">
                                    <div class="goal-title text-alt1">
                                        <span>{{ data.goal.name }}</span>
                                    </div>
                                    <div class="goal-group-weight-col">
                                        <mat-form-field appearance="outline" class="weight-field input-m">
                                            <mat-label>{{ 'NUMERIC_GOAL.GROUP_WEIGHTING' | translate }}</mat-label>
                                            <input matInput type="number" inputmode="numeric" title="Súlyozás érték: üres, vagy 1-100%" formControlName="weight">
                                        </mat-form-field>
                                    </div>
                                </div>
                                <div class="right-col">
                                    <button mat-flat-button color="primary" class="lg-button" [disabled]="!isAllChildValid || !allowOk()" (click)="onOk()" [innerHTML]="'GENERAL.SAVE_AND_CLOSE' | translate"></button>
                                    <button mat-flat-button color="primary" class="lg-button" [disabled]="!isAllChildValid || !allowOk()" (click)="onOk(false)">{{ 'GENERAL.SAVE' | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </mat-card-content>
            </mat-card>

           <mat-card class="frame main-card p-24" *ngIf="data.goal.kpiList?.length > 0">
            <mat-card-content>
                
                <ng-container *ngFor="let kpi of data.goal.kpiList; let i = index">

                    <div class="padding-bottom-m">
                        <app-goal-kpi-edit
                            [kpi]="kpi"
                            [index]="i"
                            [currentPeriod]="data.goalPeriod"
                            [aboutEmployeeId]="data.goalPeriod.employeeId"
                            (deleted)="onKpiDelete(i)"
                        ></app-goal-kpi-edit>
                    </div>

                    <div class="gradient-separator" *ngIf="i < data.goal.kpiList.length - 1"></div>
                </ng-container>

            </mat-card-content>
        </mat-card>
        
        <mat-card class="frame p-24">
            <mat-card-content>
                <div class="action-button-panel">
                    <div class="bottom-actions">
                        <button mat-flat-button (click)="showInformation()" class="lg-button button-bg-alt1 button-info">{{ 'NUMERIC_GOAL.INFORMATION' | translate }}</button>
                        <button mat-flat-button color="primary" class="lg-button new-button" [disabled]="!allowAddNew()" (click)="onNewKpi()" [innerHTML]="'NUMERIC_GOAL.NEW_GOAL_EVALUATION' | translate"></button>
                    </div>
                    <div class="footer-buttons">
                        <div class="footer-left-buttons">
                            <button mat-flat-button (click)="showInformation()" class="lg-button button-bg-alt1 button-info">{{ 'NUMERIC_GOAL.INFORMATION' | translate }}</button>
                        </div>
                        <div class="footer-right-buttons">
                            <button mat-flat-button color="primary" class="lg-button" [disabled]="!isAllChildValid || !allowOk()" (click)="onOk()" [innerHTML]="'GENERAL.SAVE_AND_CLOSE' | translate"></button>
                            <button mat-flat-button color="primary" class="lg-button" [disabled]="!isAllChildValid || !allowOk()" (click)="onOk(false)">{{ 'GENERAL.SAVE' | translate }}</button>
                        <a mat-flat-button color="primary" class="lg-button" [routerLink]="getBackLink()">{{ 'GENERAL.CANCEL' | translate }}</a>
                        </div>
                    </div>
                </div>
                </mat-card-content>
         </mat-card>
        
</div>
